const bookmarkIconSvg = `
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20">
    <path fill="none" stroke="currentColor" d="M15.3 15.312c0 .324-.211.55-.435.64a.68.68 0 0 1-.727-.142L9.9 11.757 5.662 15.81a.68.68 0 0 1-.728.141.685.685 0 0 1-.434-.64V4.689c0-.41.338-.688.687-.688h9.425c.35 0 .688.279.688.688Z"/>
  </svg>
`

class WishlistDrawer extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    super.setupListeners()

    this.renderWishlists = this.renderWishlists.bind(this)

    this.populateLists = this.populateLists.bind(this)

    this.handleRemoveItem = this.handleRemoveItem.bind(this)

    this.wishlistError = this.wishlistError.bind(this)

    this.refreshWishlist = this.refreshWishlist.bind(this)

    this.handleItemRemoved = this.handleItemRemoved.bind(this)

    this.listeners.add(
      this.els.products.element,
      'click',
      this.handleRemoveItem,
    )

    window.BAO.eventBus.addEventListener(
      window.BAO.EVENTS.WISHLIST.UPDATED,
      this.refreshWishlist,
    )

    window.SwymCallbacks = window.SwymCallbacks || []
    window.SwymCallbacks.push((swat) => {
      this.refreshWishlist()
    })
  }

  refreshWishlist () {
    window._swat.fetchLists({
      callbackFn: this.populateLists,
      errorFn: this.wishlistError,
    })
  }

  async populateLists (lists) {
    const populatedLists = lists.filter((list) => list.cnt > 0)

    if (populatedLists.length === 0) {
      this.setEmptyState()

      return
    }

    const wishlists = await Promise.all(
      populatedLists.map((list) => this.fetchListDetails(list)),
    )

    const sortedWishlists = wishlists
      .filter(Boolean)
      .sort(
        (a, b) => this.mostRecentlyAddedAt(b) - this.mostRecentlyAddedAt(a),
      )

    await this.renderWishlists(sortedWishlists)
  }

  fetchListDetails (list) {
    return new Promise((resolve) => {
      window._swat.fetchListDetails({ lid: list.lid }, resolve, () =>
        resolve(null),
      )
    })
  }

  mostRecentlyAddedAt (wishlist) {
    return wishlist.items.reduce(
      (accumulator, item) => Math.max(accumulator, item.cts ?? 0),
      0,
    )
  }

  setEmptyState () {
    this.els['view-wishlists']?.element.setAttribute('aria-hidden', true)
    this.els['footer-empty'].element.setAttribute('aria-hidden', false)
    this.els.products.element.setAttribute('aria-hidden', true)
    this.els.empty.element.setAttribute('aria-hidden', false)

    this.els['empty-label']?.element.type()
  }

  setPopulatedState () {
    this.els['view-wishlists']?.element.setAttribute('aria-hidden', false)
    this.els['footer-empty'].element.setAttribute('aria-hidden', true)
    this.els.products.element.setAttribute('aria-hidden', false)
    this.els.empty.element.setAttribute('aria-hidden', true)
  }

  handleRemoveItem (event) {
    const trigger = event.target.closest('[data-wishlist-drawer-el="remove"]')

    if (!trigger) return

    const lid = trigger.dataset.listId

    const product = {
      epi: trigger.dataset.variantId,
      empi: trigger.dataset.productId,
      du: trigger.dataset.productUrl,
    }

    window._swat.deleteFromList(
      lid,
      product,
      this.handleItemRemoved,
      this.wishlistError,
    )
  }

  handleItemRemoved () {
    this.refreshWishlist()

    window.BAO.dispatchEvent(window.BAO.EVENTS.WISHLIST.UPDATED)
  }

  async renderWishlists (wishlists) {
    const listSectionsHTML = await Promise.all(
      wishlists.map((wishlist) => this.getListSectionHTML(wishlist)),
    )

    this.els.products.element.innerHTML = listSectionsHTML.join('')

    this.setPopulatedState()
  }

  async getListSectionHTML (wishlist) {
    const itemsHTML = await this.getAllProductCardHTML(wishlist)

    if (!itemsHTML) return ''

    return `
      <div class="drw-Wishlist_Header">
        <div class="drw-Wishlist_Name">
          ${bookmarkIconSvg}

          <p class="drw-Wishlist_Heading fz-13_150">${wishlist.list.lname} [${wishlist.list.cnt}]</p>
        </div>
      </div>

      ${itemsHTML}
    `
  }

  async getAllProductCardHTML (wishlist) {
    const productCardHTML = await Promise.all(
      wishlist.items.map(
        async (product, index) =>
          await this.getProductCardHTML(product, index, wishlist.list.lid),
      ),
    )
    return productCardHTML.filter(Boolean).join('')
  }

  async getProductCardHTML (product, index, listId) {
    const productUrl = product.du.replace(
      '/products/',
      `${window.Shopify.routes.root}products/`,
    )

    return window.BAO.sectionRenderer
      .fetchSingle(
        'wishlist-drawer-product-card',
        `${productUrl}?variant=${product.epi}`,
      )
      .then((res) => {
        const newDOM = window.BAO.sectionRenderer.convertToDOM(res)
        const myself = newDOM.querySelector('article')

        if (myself) {
          return `<div class="drw-Wishlist_Item">${myself.outerHTML.replace(
            'data-wishlist-drawer-el="remove"',
            `data-wishlist-drawer-el="remove" data-product-id="${product.empi}" data-variant-id="${product.epi}" data-product-url="${product.du}" data-list-id="${listId}"`,
          )}</div>`
        }
      })
      .catch(() => {
        return null
      })
  }

  wishlistError (errorMessage) {
    // eslint-disable-next-line
    console.log(`Wishlist error: ${errorMessage}`);

    this.setEmptyState()
  }
}

if (!customElements.get('wishlist-drawer')) {
  customElements.define('wishlist-drawer', WishlistDrawer)
}
